export default "__VITE_ASSET__CBm617_q__"